import { DashboardTileType } from "../config-api/index.js";
export default DashboardTileType;
export const REDashboardTileType = [
    "KEY_NUMBERS",
    "KEY_NUMBERS_PER_CATEGORY",
    "WASTE_TYPES_IN_USE",
    "RECYCLING_RATE_OVER_TIME",
    "DEVELOPMENT_IN_WASTE_TYPES",
    "WASTE_CONTRIBUTION",
    "WASTE_TYPE_DISTRIBUTION",
    "INFRASTRUCTURE_SUMMARY",
];
export const MWMDashboardTileType = [
    "KEY_NUMBERS",
    "DEVELOPMENT_IN_WASTE_TYPES",
    "RECYCLING_RATE_OVER_TIME",
    "WASTE_TYPE_DISTRIBUTION",
    "INFRASTRUCTURE_SUMMARY",
];
//# sourceMappingURL=dashboardTileType.js.map